export default function ContactSection() {
  return (
    <section id="contact" className="py-24 md:py-32 bg-stone-50 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="mb-14">
          <p className="text-xs text-stone-400 tracking-[0.3em] uppercase font-medium mb-4">Get In Touch</p>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Contact<br />
            <span className="italic font-normal text-stone-600">CHIKO OOD</span>
          </h2>
        </div>

        {/* Main contact card */}
        <div className="bg-white rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3">
            {/* Left brand block */}
            <div className="bg-stone-900 p-10 flex flex-col justify-between gap-10">
              <div>
                <span className="text-white text-lg font-semibold tracking-widest uppercase block mb-4">
                  CHIKO OOD
                </span>
                <p className="text-stone-400 text-sm leading-relaxed">
                  A registered company of expert iOS application developers, dedicated to building privacy-first mobile tools for the modern world.
                </p>
              </div>
              <div className="w-full h-48 rounded-xl overflow-hidden opacity-60">
                <img
                  src="https://public.readdy.ai/ai/img_res/c4a0107b82ab5fdc0591032acb812a77.jpg"
                  alt=""
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right contact info */}
            <div className="lg:col-span-2 p-10 grid grid-cols-1 sm:grid-cols-2 gap-10">
              {/* Location */}
              <div className="flex flex-col gap-5">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-map-pin-2-line text-stone-700 text-lg" />
                  </div>
                  <span className="text-xs text-stone-400 tracking-[0.2em] uppercase font-medium">Location</span>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">Address</span>
                    <span className="text-sm text-stone-800">19 Ul. Georgi Kyoseivanov str.</span>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">City</span>
                    <span className="text-sm text-stone-800">Peshtera</span>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">Zip</span>
                    <span className="text-sm text-stone-800">4550</span>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">Country</span>
                    <span className="text-sm text-stone-800">Bulgaria</span>
                  </div>
                </div>
              </div>

              {/* Direct contact */}
              <div className="flex flex-col gap-5">
                <div className="flex items-center gap-3 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-stone-700 text-lg" />
                  </div>
                  <span className="text-xs text-stone-400 tracking-[0.2em] uppercase font-medium">Direct Contact</span>
                </div>
                <div className="flex flex-col gap-3">
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">Email</span>
                    <span className="text-sm text-stone-800">contact@chikoood.com</span>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className="text-xs text-stone-400 font-medium tracking-wide uppercase">Number</span>
                    <span className="text-sm text-stone-800">+1 5674025642</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom divider + copyright */}
          <div className="border-t border-stone-100 px-10 py-5">
            <p className="text-xs text-stone-400">
              &copy; {new Date().getFullYear()} CHIKO OOD. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
